import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { OverlayPanel } from 'primereact/overlaypanel'
import { Checkbox } from 'primereact/checkbox'
import { Button } from 'primereact/button'

import currecyFormater from 'currency-formatter'
import * as popUp from '../../components/toastr'
import GeneralServices from '../../app/service/generalServices'
import TableFilters from '../../components/tableFilters'
import TransactionService from '../../app/service/estoque/transactionService'
import ConstantsUtil from '../../context/constantsUtil'
import CheckNFDialog from '../../components/product/checkNFDialog'
import HandleErrorService from '../../app/service/handleErrorService'
import NFService from '../../app/service/estoque/NFService'
import PreferenciasUsuarioService from '../../app/service/preferenciasUsuarioService'
import ConfirmationDialog from '../../components/confirmationDialog'
import TooltipButton from '../../components/tooltipButton'
import { Dialog } from 'primereact/dialog'
import EditProvisaoDialog from '../../components/contasAPagar/provisoes/editProvisaoDialog'
import VisualizarDanfeButton from '../../components/nf/visualizarDanfeButton'
import AuthService from '../../app/service/authService'
import DadosDevolucaoComponent from '../../components/nf/dadosDevolucaoComponent'

class TransactionByNFTablePageable extends React.Component {

    state = {

        NFList: [],

        selectedNFs: null,
        
        expandedRows: [],
        current: null,
        
        NFToValidate: '',
        checkNFDialogVisible: false,

        NFToDelete: '',
        visibleConfirmDeleteNFDialog: false,

        expandedRows: [],

        NFToReativar: '',
        visibleConfirmReativarNFDialog: false,

        displayMotivoDialog: false,
        informacaoNFExcluida: {},
        
        displayNFDevolucaoEntradaDialog: false,
        notaFiscalDevolucaoReferenciaResponse: null,

        notaFiscalToEditProvisao: null,
        displayEditProvisaoDialog: false,

        colunasVisiveis: [],
        colunasSelecionadasMultiSelect: [],

    }


    constructor(){
        super()
        this.dt = React.createRef()
        this.tableFilters = new TableFilters();
        this.transactionService = new TransactionService();
        this.NFService = new NFService();
        this.generalServices = new GeneralServices();
        this.preferenciasUsuarioService = new PreferenciasUsuarioService();

    }

    componentDidMount(){
        this.carregarPreferenciaColunas()
    }

    getColunasDisponiveis = () => {
        /*
        Lista de colunas que podem ser exibidas na tabela, usada tanto para montar as opções do seletor
        quanto para definir o valor padrão (todas) quando ainda não há preferência salva pelo usuário.
        Precisa ser mantida em sincronia com as condições que definem cada coluna dentro do render().
        */
        let colunas = []

        colunas.push(
            {key: 'dhEmi', label: 'Data de Emissão'},
            {key: 'dataHoraImportacao', label: 'Data de Importação'},
        )

        if(this.props.tipoNF === ConstantsUtil.tipoNFEntradaLabel){
            colunas.push(
                {key: 'dataEntrada', label: 'Data Entrada'},
                {key: 'dataCompetencia', label: 'Data Competência'},
                {key: 'dataHoraValidacao', label: 'Data de Validação'},
                {key: 'emailUsuarioValidador', label: 'Usuário Validador'},
            )
        }

        colunas.push(
            {key: 'numero', label: 'Número'},
            {key: 'nomeFornecedorOuCliente', label: this.props.tipoNF === ConstantsUtil.tipoNFEntradaLabel || this.props.validateNFs ? 'Fornecedor' : 'Cliente'},
            {key: 'valorTotal', label: 'Valor Total'},
            {key: 'situacao', label: 'Situação'},
            {key: 'tipo', label: 'Tipo'},
            {key: 'chave', label: 'Chave'},
        )

        if(!this.props.simpleView){
            colunas.push(
                {key: 'tipoCriacao', label: 'Tipo de Lançamento'},
                {key: 'fonte', label: 'Fonte'},
                {key: 'sefaz', label: 'Sefaz'},
            )
        }

        colunas.push(
            {key: 'dataHoraUltimaAcaoUsuario', label: 'Data da Última Alteração'},
            {key: 'emailUsuarioUltimaAlteracao', label: 'Usuário Última Ação'},
        )

        return colunas
    }

    isColunaVisivel = (colunaKey) => {
        return this.state.colunasVisiveis.includes(colunaKey)
    }

    carregarPreferenciaColunas = () => {
        let colunasSalvas = AuthService.getPreferenciaUsuario(ConstantsUtil.preferenciaColunasTelaConferenciaNFs)
        let colunasVisiveis = (colunasSalvas && colunasSalvas.length > 0) ? colunasSalvas : this.getColunasDisponiveis().map(coluna => coluna.key)
        // console.log("colunasSalvas: ", colunasSalvas)
        // console.log("colunasVisiveis: ", colunasVisiveis)
        this.setState({colunasVisiveis, colunasSelecionadasMultiSelect: colunasVisiveis})
    }

    aplicarColunasVisiveis = () => {
        this.setState({colunasVisiveis: this.state.colunasSelecionadasMultiSelect})
    }

    aplicarESalvarColunasVisiveis = () => {
        this.setState({colunasVisiveis: this.state.colunasSelecionadasMultiSelect})
        this.preferenciasUsuarioService.salvarPreferencia(ConstantsUtil.preferenciaColunasTelaConferenciaNFs, this.state.colunasSelecionadasMultiSelect)
        .then(() => {
            AuthService.atualizaPreferenciaUsuario(ConstantsUtil.preferenciaColunasTelaConferenciaNFs, this.state.colunasSelecionadasMultiSelect)
            popUp.successPopUp("Preferência de colunas salva com sucesso!")
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }


    getList(){
        // console.log("getList")
        if(this.props.validateNFs){
            return this.state.NFList
        }
        else if(this.props.list){
            // console.log("this.props.list: ", this.props.list)
            return this.props.list
        }
    }    

    valueBodyTemplate = (rowData) => {
        return currecyFormater.format(rowData.value, {locale: 'pt-BR'})
    }

    hideDialog = () => {
        this.setState({checkNFDialogVisible: false})
    }

    delete = () => {
        if(this.state.selectedNFs){
            this.setState({displayDeleteConfirmation: true})
        } else {
            popUp.warningPopUp("Nenhuma nota foi selecionada para exclusão")
        }
    }


    checkNF = (rowData) => {
        this.setState({checkNFDialogVisible: true})
        this.setState({NFToValidate: rowData})
    }

    validateNF = () => {
        // console.log("NFToValidate: ", this.state.NFToValidate)
        var NFToValidate = this.state.NFToValidate
        NFToValidate.dataHoraEntrada = `${NFToValidate.dataEntrada} - ${NFToValidate.horaEntrada}`

        this.NFService.validateNF(this.state.NFToValidate)
        .then(async response => {
            popUp.successPopUp("Nota Fiscal validada com sucesso!")
            await this.searchNFsPendentes()
            await this.setState({NFToValidate: ''})
        }).catch(error => {
            HandleErrorService.handleError(error)
        })
        
    }    

    callExcluirNF = (rowData) => {
        this.setState({visibleConfirmDeleteNFDialog: true})
        this.setState({NFToDelete: rowData})
    }

    deleteNF = (motivoExclusao, gravarFrase) => {
        this.setState({loading: true})
        this.setState({visibleConfirmDeleteNFDialog: false})
        this.state.NFToDelete.motivoExclusao = motivoExclusao
        this.NFService.deleteNF(this.state.NFToDelete, gravarFrase)
        .then(async response => {
            popUp.successPopUp("Nota Fiscal excluída com sucesso!")
            if(this.props.validateNFs){
                await this.searchNFsPendentes()
            }
            else{
                await this.props.search()
                // this.resetaFiltrosTable()
            }
            await this.setState({NFToDelete: ''})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    resetaFiltrosTable = () => {
        this.setState({selectedNumeroNF: ''})
        this.setState({selectedDataEmissaoNF: ''})
        this.setState({selectedDataEntradaNF: ''})
        this.setState({selectedDataImportacaoNF: ''})
        this.setState({selectedFornecedorOuCliente: ''})
        this.setState({selectedvalorTotalNF: ''})
        this.setState({selectedTipoNF: ''})
        this.setState({selectedModeloNF: ''})
        this.setState({selectedChaveNF: ''})
        this.setState({selectedSituacao: ''})
        if(this.dt && this.dt.current){
            this.dt.current.reset()
        }

    }

    callRevalidarNF = (rowData) => {
        this.setState({visibleConfirmReativarNFDialog: true})
        this.setState({NFToReativar: rowData})
    }

    revalidarNF = () => {
        this.setState({loading: true})
        this.setState({visibleConfirmReativarNFDialog: false})
        this.NFService.revalidarNF(this.state.NFToReativar)
        .then(async response => {
            popUp.successPopUp("Nota Fiscal reativada com sucesso!")
            await this.props.search()
            await this.setState({NFToReativar: ''})
            this.resetaFiltrosTable()
        }).catch(error => {
            HandleErrorService.handleError(error)
        }).finally(() => {
            this.setState({loading: false})
        })
    }

    restaurarNFSaida = (notaFiscal) => {
        this.setState({loading: true})
        this.NFService.restaurarNFSaida(notaFiscal)
        .then(async response => {
            popUp.successPopUp("Nota Fiscal restaurada com sucesso!")
            await this.props.search()
        }).catch(error => {
            HandleErrorService.handleError(error)
        }).finally(() => {
            this.setState({loading: false})
        })
    }

    handleRowToggle = (e) => {
        this.setState({expandedRows: e.data})
        if(!this.state.current) {
            this.setState({current: this.dt.current})
        }
        if(!this.dt.current) {
            this.dt.current = this.state.current
        }
    }

    calculateQuantidadeAndValorTotal = (currentTableValue) => {
        // console.log("calculateQuantidadeAndValorTotal: ", currentTableValue)
        if(this.props.setInfo){
            let quantidade = 0;
            if(this.props.quantidadeNotas){
                quantidade = this.props.quantidadeNotas
            }
            else{
                quantidade = currentTableValue ? currentTableValue.length : 0
            }
            
            let valorTotal = 0
            if(currentTableValue){
                currentTableValue.forEach(item => valorTotal+= item.valorTotal)
            }
    
            this.props.setInfo({quantidade, valorTotal})
        }

        if(this.props.onTableFilter){
            this.props.onTableFilter(currentTableValue)
        }

    }

    onPage = event => {
        // console.log("onPage: ", event)
        if(this.props.researchOnPage){
            this.props.researchOnPage(event)
        }
    }

    onSort = event => {
        // console.log("onSort: ", event)
        if(this.props.researchOnSort){
            this.props.researchOnSort(event)
        }
    }

    onFilter = async event => {
        if(this.props.onFilter){
            this.props.onFilter(event)
        }

    }

    hidePesquisaNumeroDialog = () => {
        this.setState({pesquisaNumeroDialogVisible: false})
        // this.setState({inputSearchValueErrorClass: ''})
        // this.setState({errorSearchValueMessage: ''})
    }

    openMotivoDialog = async (rowData) => {
        this.NFService.verificaInformacoesDelecao(rowData.id)
        .then(async response => {
            await this.setState({displayMotivoDialog: true})
            await this.setState({informacaoNFExcluida: response.data})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    hideMotivoDialog = () => {
        this.setState({displayMotivoDialog: false})
        this.setState({informacaoNFExcluida: ''})
    }

    openDadosDevolucaoEntradaDialog = async (rowData) => {
        /*
        Renderiza um dialog com os dados da devolução.
        Pode ser a partir de uma NF de Devolução ou mesmo a partir de uma NF de Entrada que tenha sido devolvida,
        seja parcial ou totalmente.
        */
        await this.setState({displayNFDevolucaoEntradaDialog: true})
        this.searchDadosDevolucao(rowData)
    }

    
    searchDadosDevolucao = (notaFiscal) => {

        AuthService.startBlockUi()

        this.NFService.searchDadosDevolucao(notaFiscal)
        .then(response => {
            this.setState({notaFiscalDevolucaoReferenciaResponse: response.data})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    hideNFDevolucaoEntradaDialog = () => {
        this.setState({displayNFDevolucaoEntradaDialog: false})
        this.setState({notaFiscalDevolucaoReferenciaResponse: ''})
    }

    editProvisao = async notaFiscal => {
        
        if(notaFiscal.tipo === ConstantsUtil.saidaLabel){
            popUp.infoPopUp("Nota Fiscal de Saída não possui pagamento.")
            return;
        }

        //Verifica se é NF de Devolução de Entrada. Não possui provisão de pagamento.
        if(notaFiscal.tipo === ConstantsUtil.tipoNFDevolucaoEntradaLabel){
            popUp.infoPopUp("Nota Fiscal de Devolução de Entrada não possui pagamento.")
            return;
        }

        //Verifica se NF de Entrada com Bonificação Total. Se for, não possui provisão de pagamento.
        this.NFService.isBonificacaoTotal(notaFiscal)
        .then(async response => {
            if(response.data){
                //resposta veio true, ou seja, é bonificação total.
                popUp.infoPopUp("Nota Fiscal de Entrada com Bonificação total não possui pagamento.")
            }
            else{
                await this.setState({notaFiscalToEditProvisao: notaFiscal})
                this.setState({displayEditProvisaoDialog: true})
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    hideEditProvisaoDialog = () => {
        this.setState({notaFiscalToEditProvisao: null})
        this.setState({displayEditProvisaoDialog: false})
    }

    rowClass(rowData, product) {
        // console.log("rowData: ", rowData)
        // console.log("product: ", product)
        let isProdutoDaFichaDeEstoque = false

        if(product){
            if(product.uuid){
                isProdutoDaFichaDeEstoque = (product.uuid === rowData.productInfo.uuid)
            }
            else{
                isProdutoDaFichaDeEstoque = (product.id === rowData.productInfo.id)
            }
        }

        return {
            [ConstantsUtil.totaisTableLabel]: isProdutoDaFichaDeEstoque
        }
    }

    getQuantidadeNotas = () => {
        // console.log("this.props.quantidadeNotas: ", this.props.quantidadeNotas)
        if(this.props.quantidadeNotas){
            return this.props.quantidadeNotas
        }
        else{
            return this.getList() ? this.getList().length : ''
        }
    }

    render (){

        const renderMotivoDialog = () => {
            return (
                <Dialog
                    header={"Motivo da Exclusão da NF"}
                    visible={this.state.displayMotivoDialog}
                    modal
                    style={{ width: '50vw' }}
                    onHide={this.hideMotivoDialog}
                >

                    <div className="confirmation-content" >
                        <div
                            className='centraliza-conteudo-div-preserva-espaco-em-branco'
                        >
                            <strong>Motivo: </strong> {this.state.informacaoNFExcluida.motivo ? this.state.informacaoNFExcluida.motivo : 'Não informado'}
                        </div>

                        <div
                            className='centraliza-conteudo-div-preserva-espaco-em-branco'
                            style={{marginBottom: '10px'}}
                        >
                            <strong>Usuário: </strong> {this.state.informacaoNFExcluida.usuario}
                        </div>
                        
                    </div>
        
                </Dialog>                 
            )
        }

        const renderNFDevolucaoEntradaDialog = () => {
            return (
                <DadosDevolucaoComponent
                    visible={this.state.displayNFDevolucaoEntradaDialog}
                    notaFiscalDevolucaoReferenciaResponse={this.state.notaFiscalDevolucaoReferenciaResponse}
                    hideNFDevolucaoEntradaDialog={this.hideNFDevolucaoEntradaDialog}
                />                
            )            
        }

        //numeroNFFilterElement Filter
        const numeroNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedNumeroNF,
            this.props.numeroFiltroList,
            "selectedNumeroNF",
            this.props.setStateFunction,
            this.onFilter,
            "Número"
        )
        
        //dataEmissaoNF Filter
        const dataEmissaoNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedDataEmissaoNF,
            this.props.dataEmissaoSemHorarioFiltroList,
            "selectedDataEmissaoNF",
            this.props.setStateFunction,
            this.onFilter,
            "Data de Emissão"
        )

        const dataHoraImportacaoNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedDataHoraImportacaoNF,
            this.props.dataHoraImportacaoSemHorarioFiltroList,
            "selectedDataHoraImportacaoNF",
            this.props.setStateFunction,
            this.onFilter,
            "Data de Importação"
        )

        const dataHoraValidacaoNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedDataHoraValidacaoNF,
            this.props.dataHoraValidacaoSemHorarioFiltroList,
            "selectedDataHoraValidacaoNF",
            this.props.setStateFunction,
            this.onFilter,
            "Data de Validação"
        )

        const emailUsuarioValidadorNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedEmailUsuarioValidadorNF,
            this.props.emailUsuarioValidadorFiltroList,
            "selectedEmailUsuarioValidadorNF",
            this.props.setStateFunction,
            this.onFilter,
            "Email do Validador"
        )

        const dataHoraUltimaAcaoUsuarioNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedDataHoraUltimaAcaoUsuarioNF,
            this.props.dataHoraUltimaAcaoUsuarioSemHorarioFiltroList,
            "selectedDataHoraUltimaAcaoUsuarioNF",
            this.props.setStateFunction,
            this.onFilter,
            "Data da Última Alteração"
        )

        const emailUsuarioUltimaAlteracaoNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedEmailUsuarioUltimaAlteracaoNF,
            this.props.emailUsuarioUltimaAlteracaoFiltroList,
            "selectedEmailUsuarioUltimaAlteracaoNF",
            this.props.setStateFunction,
            this.onFilter,
            "Usuário Última Ação"
        )


        const dataEntradaNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedDataEntradaNF,
            this.props.dataEntradaSemHorarioFiltroList,
            "selectedDataEntradaNF",
            this.props.setStateFunction,
            this.onFilter,
            "Data de Entrada"
        )
        
        const dataCompetenciaNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedDataCompetenciaNF,
            this.props.dataCompetenciaFiltroList,
            "selectedDataCompetenciaNF",
            this.props.setStateFunction,
            this.onFilter,
            "Data Competência"
        )
        
        //dataImportacaoNF Filter
        const dataImportacaoNFFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDataImportacaoNF,
            this.getList(),
            "selectedDataImportacaoNF",
            (name, value) => this.setState({[name]: value}),
            'dataImportacaoSemHorario',
            '100%',
            "Data Importação"
        )        


        //FornecedorOuCliente Filter
        const fornecedorOuClienteFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedFornecedorOuCliente,
            this.props.nomeFornecedorOuClienteFiltroList,
            "selectedFornecedorOuCliente",
            this.props.setStateFunction,
            this.onFilter,
            "Nome"
        )
        
        //valorTotalNFFilterElement Filter
        // const valorTotalNFFilterElement = this.tableFilters.renderTableFilter(
        //     this.dt,
        //     this.state.selectedvalorTotalNF,
        //     this.getList(),
        //     "selectedvalorTotalNF",
        //     (name, value) => this.setState({[name]: value}),
        //     'valorTotal',
        //     '100%',
        //     "Valor Total"
        // )
        //FornecedorOuCliente Filter
        const valorTotalNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedvalorTotalNF,
            this.props.valorTotalFiltroList,
            "selectedvalorTotalNF",
            this.props.setStateFunction,
            this.onFilter,
            "Valor Total"
        )

        //situacaoFilterElement Filter
        // const situacaoFilterElement = this.tableFilters.renderTableFilter(
        //     this.dt,
        //     this.state.selectedSituacao,
        //     this.getList(),
        //     "selectedSituacao",
        //     (name, value) => this.setState({[name]: value}),
        //     'situacaoLabel',
        //     '50px',
        //     "Situação"
        // )
        const situacaoFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedSituacao,
            this.props.situacaoTratadaFiltroList,
            "selectedSituacao",
            this.props.setStateFunction,
            this.onFilter,
            "Situação"
        )        

        //tipoNFFilterElement Filter
        // const tipoNFFilterElement = this.tableFilters.renderTableFilter(
        //     this.dt,
        //     this.state.selectedTipoNF,
        //     this.getList(),
        //     "selectedTipoNF",
        //     (name, value) => this.setState({[name]: value}),
        //     'tipo',
        //     '50px',
        //     "Tipo"
        // )
        const tipoNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedTipoNF,
            this.props.tipoNFFiltroList,
            "selectedTipoNF",
            this.props.setStateFunction,
            this.onFilter,
            "Tipo"
        )        

        //tipoNFFilterElement Filter
        // const tipoCriacaoNFFilterElement = this.tableFilters.renderTableFilter(
        //     this.dt,
        //     this.state.selectedTipoCriacaoNF,
        //     this.getList(),
        //     "selectedTipoCriacaoNF",
        //     (name, value) => this.setState({[name]: value}),
        //     'tipoCriacao',
        //     '50px',
        //     "Tipo de Lançamento"
        // )
        const tipoCriacaoNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedTipoCriacaoNF,
            this.props.tipoCriacaoFiltroList,
            "selectedTipoCriacaoNF",
            this.props.setStateFunction,
            this.onFilter,
            "Tipo"
        )

        const fonteNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedFonteNF,
            this.props.fonteFiltroList,
            "selectedFonteNF",
            this.props.setStateFunction,
            this.onFilter,
            "Tipo"
        )

        const sefazFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedSefaz,
            this.props.sefazFiltroList,
            "selectedSefaz",
            this.props.setStateFunction,
            this.onFilter,
            "Sefaz"
        )        

        //chaveNFFilterElement Filter
        // const chaveNFFilterElement = this.tableFilters.renderTableFilter(
        //     this.dt,
        //     this.state.selectedChaveNF,
        //     this.getList(),
        //     "selectedChaveNF",
        //     (name, value) => this.setState({[name]: value}),
        //     'chave',
        //     '50px',
        //     "Chave"
        // )
        const chaveNFFilterElement = this.tableFilters.renderPaginateTableFilter(
            this.props.filterState.selectedChaveNF,
            this.props.chaveFiltroList,
            "selectedChaveNF",
            this.props.setStateFunction,
            this.onFilter,
            "Chave"
        )        

        //quantidadeProdutoNaNotaFilterElement Filter
        const quantidadeProdutoNaNotaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedQuantidadeProdutoNaNota,
            this.getList(),
            "selectedQuantidadeProdutoNaNota",
            (name, value) => this.setState({[name]: value}),
            'quantidadeProdutoNaNota',
            '100%',
            "Quantidade"
        )

        //valorUnitarioProdutoNaNotaFilterElement Filter
        const valorUnitarioProdutoNaNotaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedValorUnitarioProdutoNaNota,
            this.getList(),
            "selectedValorUnitarioProdutoNaNota",
            (name, value) => this.setState({[name]: value}),
            'valorUnitarioProdutoNaNota',
            '100%',
            "Valor"
        )

        //valorTotalProdutoNaNotaFilterElement Filter
        const valorTotalProdutoNaNotaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedValorTotalProdutoNaNota,
            this.getList(),
            "selectedValorTotalProdutoNaNota",
            (name, value) => this.setState({[name]: value}),
            'valorTotalProdutoNaNota',
            '100%',
            "Valor"
        )

        //nomeEmpresaFilterElement Filter
        const nomeEmpresaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNomeEmpresa,
            this.getList(),
            "selectedNomeEmpresa",
            (name, value) => this.setState({[name]: value}),
            'empresa.nome',
            '100%',
            "Empresa"
        )

        const rowExpansionTemplate = rowData => {
            // console.log("expansionRowData", rowData)
            return(
                <div className="">
                <h5>Itens da nota {rowData.numero}</h5>
                <DataTable
                    // ref={this.dt}
                    value={rowData.transactions}
                    className="p-datatable-sm small-font"
                    rowHover
                    scrollable
                    rowClassName={(rowData) => this.rowClass(rowData, this.props.product)}
                    scrollHeight="300px"
                    emptyMessage={"Nenhuma Nota Fiscal encontrada"}
                    paginator rows={ConstantsUtil.initialTableQuantityOption}
                    paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, rowData.transactions ? rowData.transactions.length : '')}
                    currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} Itens"
                    >

                    <Column field="productInfo.codigo" header="Código" style ={ {width: '80px'} }
                    />

                    <Column field="productInfo.descricao" header="Descrição do Produto"   style ={ {width: '140px'} } 
                        body={rowData => {
                            console.log("rowData: ", rowData)
                            return rowData.productInfo.descricao
                        }}
                    />

                    <Column field="tipoProduto.descricao" header="Tipo de Produto"   style ={ {width: '140px'} } 
                    />                    

                    <Column field="productInfo.ncm" header="NCM"   style ={ {width: '60px'} } 
                    />

                    <Column field="productInfo.cfop" header="CFOP"   style ={ {width: '60px'} } 
                    />

                    <Column field="quantidade" header="Quantidade"   style ={ {width: '140px'} }/>

                    <Column field = "valorUnitario" header="Valor Unitário" body={transaction => GeneralServices.valueBodyTemplate(transaction.valorUnitario)}   style ={ {width: '140px'} }></Column>

                    <Column
                        field = "valor"
                        header="Valor Total"
                        style ={ {width: '140px'} }
                        body={transaction => {
                            return (
                                <div>
                                    {GeneralServices.valueBodyTemplate(transaction.valor)}
                                    <TooltipButton
                                        tooltip={GeneralServices.mensagemComposicaoValorTotal(transaction)}
                                        tooltipOptions={{
                                            className: 'custom-tooltip',
                                            position: 'top'
                                        }}
                                        icon={<i className="pi pi-question" style={{fontSize: '0.8em'}}></i>}
                                        style ={{maxHeight: '25px', maxWidth: '25px'}}
                                        className="p-button-rounded p-mr-2 right-button"
                                    />                                    
                                </div>
                            )
                        }}
                    />

                </DataTable>
                
                </div>
            )
        }

        const actionValidarNFButton = (rowData) => {
            if(this.props.validateNFs){
                return (
                    <TooltipButton
                        tooltip = "Validar NF"
                        icon="pi pi-check"
                        style={ {maxHeight: '25px', maxWidth: '25px'} }
                        onClick={() => this.checkNF(rowData)} 
                    />
                )
            }
        }

        const actionExcluirNFButton = (rowData) => {
            // console.log("rowData: ", rowData)

            if(AuthService.getPerfil().isAlmoxarife){
                return <></>
            }            

            if(
                this.props.validateNFs 
                || 
                (
                  rowData && rowData.situacao === ConstantsUtil.situacaoRegular
                ) 
            ){
                return (
                    <TooltipButton
                        tooltip = {`Excluir Nota Fiscal. \n Essa NF ainda constará no sistema, mas não promoverá nenhuma alteração em Ficha de Estoque e nem nos pagamentos.`}
                        icon="pi pi-trash"
                        className="p-button-rounded p-button-danger p-mr-2"
                        style={ {maxHeight: '25px', maxWidth: '25px', marginLeft: '5px'} }
                        onClick={() => this.callExcluirNF(rowData)}
                    />
                )
            }
        }

        const actionViewDanfeNFButton = (rowData) => {
            return (
                <VisualizarDanfeButton
                    idComponenteDigital={rowData.chave}
                    // possuiArquivo={rowData.possuiDanfe}
                    possuiArquivo={rowData.tipo === ConstantsUtil.entradaLabel}
                />
            )
        }

        const actionRevalidarNFButton = (rowData) => {

            if(AuthService.getPerfil().isAlmoxarife){
                return <></>
            }

            if(
                this.props.conferenciaNF
                && (rowData.tipo === ConstantsUtil.tipoNFEntradaLabel || rowData.tipo === ConstantsUtil.tipoNFDevolucaoEntradaLabel)
                && rowData.situacaoLabel !== ConstantsUtil.situacaoRegularAguardandoValidacaoLabel
            )
            {
                return (
                    <TooltipButton
                        tooltip = {`Revalidar Nota Fiscal. \n Essa NF voltará à tela de Validação.`}
                        icon="pi pi-undo"
                        style={ {maxHeight: '25px', maxWidth: '25px', marginLeft: '5px'} }
                        onClick={() => this.callRevalidarNF(rowData)} 
                    />
                )
            }
        }

        const actionRestaurarNFSaidaButton = (rowData) => {
            if(
                this.props.conferenciaNF
                && (rowData.tipo === ConstantsUtil.tipoNFSaidaLabel)
                && rowData.situacaoLabel === ConstantsUtil.situacaoExcluidaLabel
            )
            {
                return (
                    <TooltipButton
                        tooltip = {`Restaurar Nota Fiscal.`}
                        icon="pi pi-undo"
                        style={ {maxHeight: '25px', maxWidth: '25px', marginLeft: '5px'} }
                        onClick={() => this.restaurarNFSaida(rowData)} 
                    />
                )
            }
        }

        const actionBody = (rowData) => {
            const buttons = [
                actionValidarNFButton(rowData),
                actionViewDanfeNFButton(rowData),
                actionRevalidarNFButton(rowData),
                actionRestaurarNFSaidaButton(rowData),
                actionExcluirNFButton(rowData),
            ];
        
            // Retorna null se nenhum botão for renderizado, caso contrário, retorna os botões
            for(let button of buttons){
                if(button !== undefined){
                    return buttons
                }
            }
            return null
        }

        const renderAcoesColumn = () => {
            return (
                <Column header="Ações" body={actionBody} style ={ {width: '65px'} } />
            )
        }

        const renderDataEntradaAndDataCompetenciaColumns = () => {
            if(this.props.tipoNF === ConstantsUtil.tipoNFEntradaLabel){
                return [
                    this.isColunaVisivel('dataEntrada') && (
                        <Column
                            header="Data Entrada"
                            field="dataEntradaSemHorario"
                            body={rowData => rowData.dataHoraEntrada ? rowData.dataHoraEntrada.substring(0, 21) : ''}
                            style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '30px' : '60px'} }
                            sortable={!this.props.isSearchByNumero}
                            sortField='dataEntradaJsDate'
                            filter={!this.props.isSearchByNumero} filterElement={dataEntradaNFFilterElement}
                        />
                    ),
                    this.isColunaVisivel('dataCompetencia') && (
                        <Column
                            header="Data Competência"
                            field="dataCompetencia"
                            style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '30px' : '60px'} }
                            sortable={!this.props.isSearchByNumero}
                            sortField='dataCompetenciaJsDate'
                            filter={!this.props.isSearchByNumero} filterElement={dataCompetenciaNFFilterElement}
                        />
                    ),
                    this.isColunaVisivel('dataHoraValidacao') && (
                        <Column
                            header="Data de Validação"
                            field="dataHoraValidacaoSemHorario"
                            body={rowData => rowData.dataHoraValidacao ? rowData.dataHoraValidacao.substring(0, 21) : ''}
                            style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '30px' : '60px'} }
                            sortable={!this.props.isSearchByNumero}
                            sortField='dataHoraValidacaoJsDate'
                            filter={!this.props.isSearchByNumero} filterElement={dataHoraValidacaoNFFilterElement}
                        />
                    ),
                    this.isColunaVisivel('emailUsuarioValidador') && (
                        <Column
                            header="Usuário Validador"
                            field="emailUsuarioValidador"
                            style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '30px' : '50px'} }
                            sortable={!this.props.isSearchByNumero}
                            filter={!this.props.isSearchByNumero} filterElement={emailUsuarioValidadorNFFilterElement}
                        />
                    ),
                    this.isColunaVisivel('dataHoraUltimaAcaoUsuario') && (
                        <Column
                            header="Data da Última Alteração"
                            field="dataHoraUltimaAcaoUsuarioSemHorario"
                            body={rowData => rowData.dataHoraUltimaAcaoUsuario ? rowData.dataHoraUltimaAcaoUsuario.substring(0, 21) : ''}
                            style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '30px' : '60px'} }
                            sortable={!this.props.isSearchByNumero}
                            sortField='dataHoraUltimaAcaoUsuarioJsDate'
                            filter={!this.props.isSearchByNumero} filterElement={dataHoraUltimaAcaoUsuarioNFFilterElement}
                        />
                    ),

                    this.isColunaVisivel('emailUsuarioUltimaAlteracao') && (
                        <Column
                            header="Usuário Última Ação"
                            field="emailUsuarioUltimaAlteracao"
                            style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '30px' : '50px'} }
                            sortable={!this.props.isSearchByNumero}
                            filter={!this.props.isSearchByNumero} filterElement={emailUsuarioUltimaAlteracaoNFFilterElement}
                        />
                    )                    
                ]
            }
        }

        const actionBodyProvisao = (notaFiscal) => {
            if(notaFiscal.situacaoLabel === ConstantsUtil.situacaoRegularValidadaLabel){
                return (
                    <React.Fragment>
                        <TooltipButton
                            tooltip='Dados de Pagamento'
                            tooltipOptions={{ position: 'right' }}
                            icon={<i className="pi pi-pencil" style={{fontSize: '1em'}}></i>}
                            onClick={() => this.editProvisao(notaFiscal)}
                            style={{maxHeight: '25px', maxWidth: '25px'}}
                        />
    
                    </React.Fragment>
                );
            }
        }

        const renderColunaDadosPagamentoNF = () => {
            if(!this.props.validateNFs && !this.props.simpleView && this.props.tipoNF !== ConstantsUtil.tipoNFSaidaLabel){
                return (
                    <Column header="Dados de pagamento da NF" body={actionBodyProvisao} style ={ {width: '2.5rem'} }/>
                )
            }
        }

        const renderSimpleView = () => {
            return (
                [
                    this.isColunaVisivel('dhEmi') && (
                        <Column
                            header="Data de Emissão"
                            field="dEmiSemHorario"
                            body={rowData => rowData.dhEmi.substring(0, 21)}
                            style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '30px' : '60px'} }
                            sortable={!this.props.isSearchByNumero}
                            sortField='dhEmiJsDate'
                            filter={!this.props.isSearchByNumero} filterElement={dataEmissaoNFFilterElement}
                        />
                    ),

                    this.isColunaVisivel('dataHoraImportacao') && (
                        <Column
                            header="Data de Importação"
                            field="dataHoraImportacaoSemHorario"
                            body={rowData => rowData.dataHoraImportacao.substring(0, 21)}
                            style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '30px' : '60px'} }
                            sortable={!this.props.isSearchByNumero}
                            sortField='dataHoraImportacaoJsDate'
                            filter={!this.props.isSearchByNumero} filterElement={dataHoraImportacaoNFFilterElement}
                        />
                    ),

                    renderDataEntradaAndDataCompetenciaColumns(),

                    this.isColunaVisivel('numero') && (
                        <Column
                            header="Número"
                            field="numero"
                            style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '25px' : '40px'} }
                            sortable={!this.props.isSearchByNumero}
                            filter={!this.props.isSearchByNumero} filterElement={numeroNFFilterElement}
                        />
                    ),

                    this.isColunaVisivel('nomeFornecedorOuCliente') && (
                        <Column
                            header={this.props.tipoNF === ConstantsUtil.tipoNFEntradaLabel || this.props.validateNFs ? "Fornecedor" : "Cliente"}
                            field="nomeFornecedorOuCliente"
                            body={ (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.nomeFornecedorOuCliente, rowIndex)}
                            style ={ {width: this.props.insideFichaDeEstoqueDetalhamento ? '30px' : '80px'} }
                            sortable={!this.props.isSearchByNumero}
                            filter={!this.props.isSearchByNumero} filterElement={fornecedorOuClienteFilterElement}
                        />
                    ),

                    this.isColunaVisivel('valorTotal') && (
                        <Column field = "valorTotal" header="Valor Total"
                            body={NF => GeneralServices.valueBodyTemplate(NF.valorTotal)}
                            style ={ {width: '40px'} }
                            sortable={!this.props.isSearchByNumero}
                            filter={!this.props.isSearchByNumero} filterElement={valorTotalNFFilterElement}
                        />
                    ),

                    this.isColunaVisivel('situacao') && (
                        <Column
                            header="Situação"
                            field="situacaoLabel"
                            sortable={!this.props.isSearchByNumero}
                            style ={ {width: '30px'} }
                            filter={!this.props.isSearchByNumero} filterElement={situacaoFilterElement}
                            body = { (rowData, rowIndex) => GeneralServices.renderStyledSituacaoNF(
                                rowData.situacaoLabel,
                                rowIndex,
                                () => {this.openMotivoDialog(rowData)}
                            )}
                        />
                    ),

                    this.isColunaVisivel('tipo') && (
                        <Column
                            header="Tipo"
                            field="tipo"
                            sortable={!this.props.isSearchByNumero}
                            style ={ {width: '30px'} }
                            filter={!this.props.isSearchByNumero} filterElement={tipoNFFilterElement}
                            body = { (rowData, rowIndex) => GeneralServices.renderStyledTipoNF(
                                rowData,
                                rowIndex,
                                () => {this.openDadosDevolucaoEntradaDialog(rowData)}
                            )}
                        />
                    ),
                    this.isColunaVisivel('chave') && (
                        <Column
                            header="Chave"
                            field="chave"
                            style ={ {width: '20px'} }
                            body={rowData => GeneralServices.copyChNFeBody(rowData.chave)}
                            filter={!this.props.isSearchByNumero} filterElement={chaveNFFilterElement}
                        />
                    )
                ]
            )
        }

        const renderQuantidadeProdutoNaNota = () => {
            if(this.props.insideFichaDeEstoqueDetalhamento){
                return (
                    <Column
                        header="Quantidade"
                        field="quantidadeProdutoNaNota"
                        style ={ {width: '30px'} }
                        sortable={!this.props.isSearchByNumero}
                        filter={!this.props.isSearchByNumero} filterElement={quantidadeProdutoNaNotaFilterElement}
                    />
                )
            }
        }

        const renderValorProdutoNaNota = () => {
            if(this.props.insideFichaDeEstoqueDetalhamento){
                return (
                    [
                        <Column
                            header="Vr Unit"
                            field="valorUnitarioProdutoNaNota"
                            style ={ {width: '30px'} }
                            sortable={!this.props.isSearchByNumero}
                            filter={!this.props.isSearchByNumero} filterElement={valorUnitarioProdutoNaNotaFilterElement}
                        />,
                        <Column
                            header="Vr Total"
                            field="valorTotalProdutoNaNota"
                            style ={ {width: '30px'} }
                            sortable={!this.props.isSearchByNumero}
                            filter={!this.props.isSearchByNumero} filterElement={valorTotalProdutoNaNotaFilterElement}
                        />
                    ]
                )
            }
        }

        const renderConversao = () => {
            if(this.props.insideFichaDeEstoqueDetalhamento && this.props.tipoDetalhamento === ConstantsUtil.entradaLabel){
                return (
                    <Column
                        header="Conversão"
                        field="conversao"
                        style ={ {width: '30px'} }
                        // sortable
                        // filter filterElement={tipoCriacaoNFFilterElement}
                    />
                )
            }
        }

        const renderRemainderView = () => {
            if(!this.props.simpleView){
                return (
                    [
                        this.isColunaVisivel('tipoCriacao') && (
                            <Column
                                header="Tipo de Lançamento"
                                field="tipoCriacao"
                                sortable={!this.props.isSearchByNumero}
                                style ={ {width: '60px'} }
                                filter={!this.props.isSearchByNumero} filterElement={tipoCriacaoNFFilterElement}
                            />
                        ),

                        this.isColunaVisivel('fonte') && (
                            <Column
                                header="Fonte"
                                field="fonte"
                                sortable={!this.props.isSearchByNumero}
                                style ={ {width: '40px'} }
                                filter={!this.props.isSearchByNumero} filterElement={fonteNFFilterElement}
                            />
                        ),

                        this.isColunaVisivel('sefaz') && (
                            <Column
                                header="Sefaz"
                                field="sefaz"
                                sortable={!this.props.isSearchByNumero}
                                style ={ {width: '40px'} }
                                filter={!this.props.isSearchByNumero} filterElement={sefazFilterElement}
                                body={rowData => rowData.sefaz ? 'Sim' : 'Não'}
                            />
                        ),

                        renderAcoesColumn()

                    ]
                )
            }
        }

        const renderEmpresa = () => {
            if(this.props.unificar){
                return (
                    <Column
                        header="Empresa"
                        field="empresa.nome"
                        style ={ {width: '30px'} }
                        sortable={!this.props.isSearchByNumero}
                        filter={!this.props.isSearchByNumero} filterElement={nomeEmpresaFilterElement}
                    />
                )
            }
        }


        const toggleColunaSelecionada = (colunaKey) => {
            let colunasSelecionadasMultiSelect = this.state.colunasSelecionadasMultiSelect.includes(colunaKey)
                ? this.state.colunasSelecionadasMultiSelect.filter(key => key !== colunaKey)
                : [...this.state.colunasSelecionadasMultiSelect, colunaKey]
            this.setState({colunasSelecionadasMultiSelect})
        }

        const renderSeletorDeColunas = () => {

            const colunasDisponiveis = this.getColunasDisponiveis()
            const todasAsChaves = colunasDisponiveis.map(coluna => coluna.key)
            const todasSelecionadas = todasAsChaves.length > 0 && todasAsChaves.every(key => this.state.colunasSelecionadasMultiSelect.includes(key))

            const toggleTodasColunas = () => {
                this.setState({colunasSelecionadasMultiSelect: todasSelecionadas ? [] : todasAsChaves})
            }

            return (
                <div className="mb-2">
                    <Button
                        label="Colunas"
                        icon="pi pi-table"
                        className="p-button-outlined"
                        onClick={e => this.colunasOverlayPanel.toggle(e)}
                    />

                    <OverlayPanel ref={ref => this.colunasOverlayPanel = ref} showCloseIcon dismissable style={{width: '280px'}}>

                        <div style={{fontWeight: 'bold', color: '#2c4670', marginBottom: '10px'}}>
                            Colunas
                        </div>

                        <div className="p-field-checkbox" style={{marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #e0e0e0'}}>
                            <Checkbox
                                inputId="coluna-todas"
                                checked={todasSelecionadas}
                                onChange={toggleTodasColunas}
                            />
                            <label htmlFor="coluna-todas" style={{marginLeft: '8px', fontWeight: 'bold'}}>
                                {todasSelecionadas ? 'Desmarcar Todas' : 'Marcar Todas'}
                            </label>
                        </div>

                        <div style={{maxHeight: '200px', overflowY: 'auto'}}>
                            {colunasDisponiveis.map(coluna => (
                                <div key={coluna.key} className="p-field-checkbox" style={{marginBottom: '8px'}}>
                                    <Checkbox
                                        inputId={`coluna-${coluna.key}`}
                                        checked={this.state.colunasSelecionadasMultiSelect.includes(coluna.key)}
                                        onChange={() => toggleColunaSelecionada(coluna.key)}
                                    />
                                    <label htmlFor={`coluna-${coluna.key}`} style={{marginLeft: '8px', fontWeight: 'normal'}}>
                                        {coluna.label}
                                    </label>
                                </div>
                            ))}
                        </div>

                        <div style={{display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #e0e0e0'}}>
                            <Button
                                label="Aplicar"
                                className="p-button-outlined p-button-sm"
                                onClick={() => { this.aplicarColunasVisiveis(); this.colunasOverlayPanel.hide() }}
                            />
                            <Button
                                label="Aplicar e Salvar"
                                className="p-button-sm"
                                onClick={() => { this.aplicarESalvarColunasVisiveis(); this.colunasOverlayPanel.hide() }}
                            />
                        </div>

                    </OverlayPanel>
                </div>
            )
        }

        return (
            <div className="">
            <div className="card">

                {renderSeletorDeColunas()}

                <DataTable
                    ref={this.dt}
                    value={this.getList()}
                    // value={[]}
                    className="p-datatable-sm small-font"
                    rowHover
                    selection={this.state.selectedNFs}
                    onSelectionChange={(e) => this.setState({selectedNFs: e.value})}
                    scrollable
                    scrollHeight={this.props.insideFichaDeEstoqueDetalhamento ? "300px" : "500px"}
                    loading={this.state.loading || this.props.loading}
                    emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                    expandableRows={true}
                    expandedRows = {this.state.expandedRows}
                    onRowToggle={this.handleRowToggle}
                    rowExpansionTemplate={rowExpansionTemplate}
                    onValueChange={this.calculateQuantidadeAndValorTotal} //onFilter
                    onPage={this.onPage}
                    onSort={this.onSort}
                    sortField={this.props.sortField}
                    sortOrder={this.props.sortOrder}
                    // showGridlines
                    dataKey="id"
                    paginator
                    // rows={ConstantsUtil.initialTableQuantityOption}
                    // paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.getList() ? this.getList().length : '')}
                    paginatorTemplate={GeneralServices.tablePaginatorSpecific(ConstantsUtil.initialRowsInNFtable, 50, 100)}
                    // last
                    // totalRecords={this.state.totalRecords}
                    lazy //para que sobrescrita de totalRecords funcione
                    // first={this.state.firstInTable}
                    first={this.props.firstInTable}
                    // rows={this.state.rowsInTable}
                    rows={this.props.rowsInTable}
                    totalRecords={this.getQuantidadeNotas()}
                    // currentPageReportTemplate={`Mostrando de {first} ao {last} de ${this.getQuantidadeNotas()} Notas Fiscais`}
                    currentPageReportTemplate={`Mostrando de {first} ao {last} de {totalRecords} Notas Fiscais`}
                >

                    <Column expander style={{ width: '20px' }} />

                    {renderColunaDadosPagamentoNF()}

                    {renderSimpleView()}

                    {renderQuantidadeProdutoNaNota()}
                    {renderConversao()}
                    {renderValorProdutoNaNota()}

                    {renderRemainderView()}

                    {renderEmpresa()}

                </DataTable>

                {renderMotivoDialog()}
                
                {renderNFDevolucaoEntradaDialog()}

            </div>

            <CheckNFDialog
                visible={this.state.checkNFDialogVisible}
                hideDialog={this.hideDialog}
                register={false}
                NFToValidate={this.state.NFToValidate}
                save={this.validateNF}
            />

            <ConfirmationDialog
                header={"Deletar Nota Fiscal"}
                visible={this.state.visibleConfirmDeleteNFDialog}
                confimationMessage="Deseja Deletar esta Nota Fiscal?"
                confirm={this.deleteNF}
                hide={() => this.setState({visibleConfirmDeleteNFDialog: false})}
                hasConfirmationMessage
                motivoDeleteNF
                tipoFrase={ConstantsUtil.tipoFraseMotivoExclusaoNF}
                placeholderConfirmationMessage="Motivo"
            />    

            <ConfirmationDialog
                header={"Reativar Nota Fiscal"}
                visible={this.state.visibleConfirmReativarNFDialog}
                confimationMessage="Deseja Revalidar esta Nota Fiscal?"
                confirm={this.revalidarNF}
                hide={() => this.setState({visibleConfirmReativarNFDialog: false})}
            />

            <EditProvisaoDialog
                visible={this.state.displayEditProvisaoDialog}
                // provisaoId={this.state.idProvsisaoToEdit}
                notaFiscal={this.state.notaFiscalToEditProvisao}
                search={this.props.search}
                startLoadingTable={this.props.startLoadingTable}
                finishLoadingTable={this.props.finishLoadingTable}
                hideDialog={this.hideEditProvisaoDialog}
                tipoNotaFiscal={ConstantsUtil.tipoNotaFiscalMercadoria}
            />              

        </div>
        )
    }


}  

export default TransactionByNFTablePageable